import { LoggedInUser, LoggedInUserCodec } from '@/models/User'
import { chain, isRight } from 'fp-ts/lib/Either'
import { pipe } from 'fp-ts/lib/function'
import { parse } from 'fp-ts/lib/Json'
import * as T from 'io-ts'
import Vue from 'vue'
import Vuex from 'vuex'
import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators'

const StateCodec = T.type({
  user: T.union([T.null, LoggedInUserCodec]),
})

type StateInterface = T.TypeOf<typeof StateCodec>

function getStateFromLocalStorage(): StateInterface | null {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const either = pipe(localStorage.vuex, parse, chain(StateCodec.decode))
  return isRight(either) ? either.right : null
}

function saveStateToLocalStorage(s: StateInterface) {
  localStorage.setItem('vuex', JSON.stringify(s))
}

@Module
class State extends VuexModule {
  s: StateInterface = getStateFromLocalStorage() ?? { user: null }

  @Mutation
  setUser(user: LoggedInUser) {
    this.s.user = user
    saveStateToLocalStorage(this.s)
  }

  @Mutation
  signOut() {
    this.s.user = null
    saveStateToLocalStorage(this.s)
  }

  @Action
  snackbar() {
    // empty
  }
}

Vue.use(Vuex)

const store = new Vuex.Store<{ State: State }>({
  modules: {
    State,
  },
})

export default store
